'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetStudentMentoringStateOutputDTO } from '@algoacademy/backend/modules/payment/endpoints/queries/get-student-mentoring-state/output.dto';
import { ErrorMessage, Field, Fieldset, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { H4 } from '@algoacademy/design-system/web/typography/Heading';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import type { UseFormReturn } from 'react-hook-form';
import type { MentoringOfferFormSchema } from '../../schema';
type BuyerDataSectionProps = {
  form: UseFormReturn<MentoringOfferFormSchema>;
  isChangeMode: boolean;
  current: NonNullable<GetStudentMentoringStateOutputDTO['current']> | null;
};
export function BuyerDataSection(t0) {
  const $ = _c(37);
  const {
    form,
    isChangeMode,
    current
  } = t0;
  if (isChangeMode && current !== null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <H4>Dane kupującego</H4>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Label>Imię i nazwisko kupującego</Label>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== current.buyerName) {
      t3 = <Field className="flex-1">{t2}<Input type="text" value={current.buyerName} readOnly={true} aria-readonly="true" /></Field>;
      $[2] = current.buyerName;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Label>E-mail kupującego</Label>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== current.buyerEmail) {
      t5 = <Field className="flex-1">{t4}<Input type="email" value={current.buyerEmail} readOnly={true} aria-readonly="true" /></Field>;
      $[5] = current.buyerEmail;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t3 || $[8] !== t5) {
      t6 = <Fieldset className="flex flex-col gap-3 lg:flex-row">{t3}{t5}</Fieldset>;
      $[7] = t3;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <P3 className="text-contentSecondary">Nie możesz zmienić kupującego, ani ucznia - aby zmienić te ustawienia anuluj obecną ofertę, a następnie stwórz nową.</P3>;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== t6) {
      t8 = <section className="space-y-3">{t1}{t6}{t7}</section>;
      $[11] = t6;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  let t1;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header className="flex flex-col gap-1"><H4>Dane kupującego</H4><P3 className="text-contentSecondary">Zostaw puste, gdy uczeń sam kupuje – użyjemy jego adresu w ofercie i w Stripe.</P3></header>;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label>Imię i nazwisko</Label>;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== form) {
    t3 = form.register("buyerName");
    $[15] = form;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t3) {
    t4 = <Input {...t3} type="text" autoComplete="off" />;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const t5 = form.formState.errors.buyerName?.message;
  let t6;
  if ($[19] !== t5) {
    t6 = <ErrorMessage>{t5}</ErrorMessage>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t6) {
    t7 = <Field className="flex-1">{t2}{t4}{t6}</Field>;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Label>Adres e-mail</Label>;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== form) {
    t9 = form.register("buyerEmail");
    $[25] = form;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t9) {
    t10 = <Input {...t9} type="email" autoComplete="off" />;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const t11 = form.formState.errors.buyerEmail?.message;
  let t12;
  if ($[29] !== t11) {
    t12 = <ErrorMessage>{t11}</ErrorMessage>;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12) {
    t13 = <Field className="flex-1">{t8}{t10}{t12}</Field>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t7) {
    t14 = <section className="space-y-3">{t1}<Fieldset className="flex flex-col gap-3 lg:flex-row">{t7}{t13}</Fieldset></section>;
    $[34] = t13;
    $[35] = t7;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
}